import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'
import {getUserLogin} from '@/script/apiService/api.js'

let root = process.env.VUE_APP_PACACLOUND_ROOT;

Vue.use(VueRouter);

const routes = [
  {
    path: `${root}`,
    name: "Home",
    redirect: { name: 'AdminSummary' }
  },
  {
    path: `${root}/public/terms`,
    name: "Terms",
    component: () => {
      return import("@/view/public/terms.vue")
    }
  },
  {
    path: `${root}/public/privacy`,
    name: "Privacy",
    component: () => {
      return import("@/view/public/privacy.vue")
    }
  },
  {
    path: `${root}/login`,
    name: "Login",
    component: () => {
      return import("@/view/login/login.vue")
    },
  },
  {
    path: `${root}/login/signIn`,
    name: "SignIn",
    component: () => {
      return import("@/view/login/signIn.vue")
    }
  },
  {
    path: `${root}/login/forgetPassword`,
    name: "ForgetPassword",
    component: () => {
      return import("@/view/login/forgetPassword.vue")
    }
  },
  {
    path: `${root}/report/ntpReport`,
    name: "NtpReport",
    component: () => {
      return import("@/view/report/ntpReport.vue")
    }
  },
  {
    path: `${root}/adminArea/summary`,
    name: "AdminSummary",
    component: () => {
      return import("@/view/adminArea/summary.vue")
    }
  },
  {
    path: `${root}/adminArea/reg`,
    name: "Reg",
    component: () => {
      return import("@/view/adminArea/reg.vue")
    }
  },
  {
    path: `${root}/adminArea/regList`,
    name: "RegList",
    component: () => {
      return import("@/view/adminArea/regList.vue")
    }
  },
  {
    path: `${root}/logout`,
    name: "Logout",
    component: () => {
      return import("@/view/logout/logout.vue")
    }
  },
  {
    path: `${root}/resetNickname`,
    name: "ResetNickname",
    component: () => {
      return import("@/view/account/resetNickname.vue")
    }
  },
  {
    path: `${root}/resetPassword`,
    name: "ResetPassword",
    component: () => {
      return import("@/view/account/resetPassword.vue")
    }
  },
  {
    path: `${root}*`,
    redirect: {name: 'Home'}
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

let checkTokenTimeOnce = async function(){
  let res = await getUserLogin();
  if(res.is_partner != 1 && res.is_admin != 1){
    store.commit({
      type: "setUserInfo",
      userInfo: null
    })
    return false;
  }
  checkTokenTimeOnce = function(){};
}
router.beforeEach(async (to,from,next) => {
  if(window.innerWidth < 769){
    store.commit({
      type: 'setAsideCollapseButton',
      isOpen: false
    })
  }
  if(to.path == `${root}/public/terms` || to.path == `${root}/public/privacy`){
    next();
  }else{
    if(to.path != `${root}/logout` && store.state.userInfo){
      await checkTokenTimeOnce();
    }
    if(to.path.indexOf(`${root}/login`) == -1 && !store.state.userInfo){
      next(`${root}/login`);
    }else if(to.path.indexOf(`${root}/login`) != -1 && !store.state.userInfo){
      next();
    }else if(to.path.indexOf(`${root}/login`) != -1 && store.state.userInfo){
      next(from);
    }else{
      next();
    }
  }
})

export default router;
